import { Nav } from 'UI/elements';
import { ProtectedLayoutOutlet } from '../protected';
import styles from './DashboardLayout.module.scss';
import { useAuthentication } from 'UI/hooks/useAuthentication';

export function DashboardLayout(): React.ReactElement {
  const { authed } = useAuthentication();

  return (
    <div className={styles.dashboardLayout}>
      <Nav />
      <ProtectedLayoutOutlet authed={authed} />
    </div>
  );
}
